import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const it = {
  nav: { home: "Home", services: "Soluzioni", method: "Metodo", portfolio: "Portfolio", about: "Chi siamo", contact: "Contatti", teatro: "Teatro Dinamico", draw: "Disegna", book: "Prenota visita", staff: "Area Staff" },
  home: {
    eyebrow: "Studio di progettazione",
    heroTitle: "Progettiamo spazi che raccontano di te.",
    heroSub: "Progettazione innovativa con spazio dimostrativo unico per visualizzare i tuoi progetti in scala reale.",
    ctaDraw: "Disegna la tua stanza",
    ctaBook: "Prenota una visita",
    servicesTitle: "Cosa facciamo",
    servicesSub: "Tre modi di prenderci cura del tuo spazio.",
    methodTitle: "Il nostro metodo",
    methodSub: "Un processo semplice, trasparente, guidato.",
    portfolioTitle: "Ultime realizzazioni",
    portfolioSub: "Progetti recenti dello studio.",
    seeAll: "Vedi tutti i progetti",
  },
  services: {
    title: "Le Nostre Soluzioni",
    sub: "Dalla progettazione alla realizzazione, offriamo soluzioni complete per ogni esigenza edilizia e di design.",
    items: [
      { title: "Progettazione Architettonica", desc: "Progetti personalizzati per edifici residenziali e commerciali con attenzione ai dettagli e alle esigenze del cliente." },
      { title: "Teatro Dinamico", desc: "Unico nel suo genere: uno spazio dove riprodurre la tua stanza in scala reale con blocchi movibili per visualizzare arredi e dimensioni." },
      { title: "Design d'Interni", desc: "Soluzioni innovative per spazi interni che combinano funzionalità ed estetica, creando ambienti unici e armoniosi." },
      { title: "Consulenza e Planimetrie", desc: "Analisi dettagliata degli spazi e creazione di planimetrie tecniche con supporto completo nella fase di realizzazione." },
      { title: "Ristrutturazioni", desc: "Riqualificazione di edifici con soluzioni moderne che rispettano la struttura originale e migliorano gli spazi." },
      { title: "Direzione Lavori e Sicurezza", desc: "Supervisione completa dei lavori di costruzione per garantire la qualità e il rispetto dei tempi e del budget concordati." },
    ],
  },
  method: {
    title: "Il nostro metodo",
    sub: "Nessun tecnicismo. Tre passi chiari per arrivare al tuo progetto.",
    steps: [
      { n: "01", t: "Ascolto", d: "Capiamo insieme come vivi, come vorresti vivere, e cosa ti piace davvero." },
      { n: "02", t: "Disegno guidato", d: "Con il nostro tool disegni la tua idea o ci mandi uno schizzo. Bastano pochi minuti." },
      { n: "03", t: "Progetto e cantiere", d: "Ti consegniamo il progetto e ti seguiamo, anche in cantiere, fino alla fine." },
    ],
  },
  portfolio: { title: "Portfolio", sub: "Alcuni dei progetti che abbiamo realizzato.", all: "Tutti", year: "Anno", categories: { residential: "Residenziale", commercial: "Commerciale", interior: "Interior Design" } },
  contact: {
    title: "Parliamone",
    sub: "Scrivici, ti risponderemo entro 24 ore.",
    name: "Nome",
    email: "Email",
    message: "Il tuo messaggio",
    send: "Invia",
    sent: "Messaggio inviato. Ci sentiamo presto!",
  },
  booking: {
    title: "Prenota una visita",
    sub: "Vieni a trovarci nel nostro spazio dimostrativo.",
    chooseSlot: "Scegli una data e un orario",
    noSlots: "Nessuno slot disponibile al momento. Riprova più tardi.",
    yourData: "I tuoi dati",
    name: "Nome e cognome",
    email: "Email",
    phone: "Telefono",
    reason: "Motivo della visita (opzionale)",
    confirm: "Conferma prenotazione",
    success: "Prenotazione confermata! Controlla la tua email.",
  },
  draw: {
    title: "Raccontaci il tuo spazio",
    sub: "<p>Hai già un'idea o vuoi modificare la tua stanza? <strong>Disegnala nel nostro tool</strong>, in modo semplice, poi inviaci la tua bozza insieme a qualche foto e alle tue note.</p><p><strong>Non serve essere un professionista</strong>: il tuo disegno ci aiuta a capire come immagini il tuo spazio, cosa vuoi modificare e quali sono le tue esigenze.</p><p>Raccogliamo tutte le informazioni che ci fornisci e le trasformiamo in un <strong>disegno tecnico chiaro e dettagliato</strong>, che puoi scegliere in versione base o dettagliata.</p><ul><li><strong>Disegno tecnico base</strong>, per avere una rappresentazione del tuo spazio.</li><li><strong>Disegno tecnico dettagliato</strong>, con consigli di arredo e divisione degli spazi, per aiutarti a sviluppare al meglio la tua idea.</li></ul><p><strong>Tu ci racconti come immagini il tuo spazio. Noi trasformiamo la tua idea in un progetto tecnico.</strong></p>",
    modeSketch: "Disegno Libero",
    modeSketchDesc: "Disegno libero su foglio bianco.",
    modeGuided: "Disegno su Griglia",
    modeGuidedDesc: "Disegno preciso su griglia con misure in centimetri.",
    start: "Inizia",
    back: "Torna indietro",
    tools: { pencil: "Matita", eraser: "Gomma", text: "Testo", clear: "Pulisci", undo: "Annulla" },
    guide1: "Inizia disegnando il perimetro della stanza.",
    guide2: "Indica dove sono le porte e le finestre.",
    guide3: "Scrivi le misure vicino alle pareti (es: 3.5m).",
    guidedTools: { wall: "Parete", door: "Porta", window: "Finestra", select: "Seleziona", delete: "Elimina" },
    guidedGuide1: "Clicca il primo punto della parete, poi digita la lunghezza in cm e premi Invio per crearla nella direzione del cursore.",
    guidedGuide2: "Aggiungi porte e finestre sopra le pareti.",
    guidedGuide3: "Quando hai finito, invia il progetto: genereremo il file DXF.",
    wizard: {
      stepOf: "Step {{n}}/4",
      backToDrawing: "Torna indietro",
      titles: {
        s1: "Dettagli progetto",
        s2: "I tuoi contatti",
        s3: "Scegli il disegno tecnico",
        s4: "Metodo di pagamento",
      },
      project: "Progetto",
      interventionType: "Tipo di intervento",
      interventions: {
        restructure: "Ristrutturazione intera stanza",
        furniture: "Sostituzione arredi",
      },
      roomType: "Tipologia di stanza",
      roomOther: "Specifica il tipo di stanza",
      rooms: {
        living: "Soggiorno", kitchen: "Cucina", bedroom: "Camera da letto",
        kids: "Cameretta", bathroom: "Bagno", office: "Studio",
        entrance: "Ingresso", dining: "Sala da pranzo", other: "Altro",
      },
      notes: "Note libere",
      photos: "Foto della stanza (opzionale)",
      photosSelected: "{{n}} foto selezionate",
      name: "Nome", email: "Email", phone: "Telefono",
      privacy: "Accetto la ",
      privacyLink: "Privacy Policy",
      privacyRest: " e acconsento al trattamento dei miei dati per la gestione del progetto e la comunicazione con lo studio.",
      pitch: "Tu ci racconti come immagini il tuo spazio. Noi trasformiamo la tua idea in un progetto tecnico.",
      packages: {
        base: { name: "Disegno tecnico base", desc: "Per avere una rappresentazione tecnica del tuo spazio." },
        detail: { name: "Disegno tecnico dettagliato", desc: "Con consigli di arredo e divisione degli spazi, per aiutarti a sviluppare al meglio la tua idea." },
      },
      perRoom: "per stanza",
      roomsCount: "Numero di stanze",
      roomsHint: "Il prezzo si moltiplica per ogni stanza",
      total: "Totale",
      totalPreview: "Totale",
      priceIncl: "IVA inclusa",
      choosePay: "Scegli come vuoi pagare.",
      pay: {
        stripe: { l: "Carta di credito / debito", d: "Checkout sicuro Stripe — Visa, Mastercard, Apple Pay, Google Pay" },
        bonifico: { l: "Bonifico bancario", d: "Ti mostriamo IBAN e istruzioni dopo l'invio — il progetto parte al ricevimento" },
        paypal: { l: "PayPal", d: "Reindirizzamento sicuro a PayPal — paga con account PayPal o carta" },
      },
      bonifico: {
        title: "Dati per il bonifico",
        holder: "Intestatario",
        bank: "Banca",
        iban: "IBAN",
        causal: "Causale",
        amount: "Importo",
        holderVal: "Plan It Studio SRL STP",
        bankVal: "Intesa Sanpaolo — Filiale Spoleto, Piazza Garibaldi",
        note: "Riceverai una copia via email dopo l'invio. Il progetto verrà avviato al ricevimento del bonifico.",
        successNote: "Ti abbiamo inviato una copia via email. Il progetto verrà avviato al ricevimento del bonifico.",
        yourName: "{nome}",
      },
      next: "Avanti →",
      back: "← Indietro",
      submitPay: "Paga e invia",
      submitSend: "Invia progetto",
      sending: "…",
      successBonifico: "Progetto inviato",
      successBonificoSub: "Abbiamo ricevuto la tua richiesta. Completa il pagamento con un bonifico usando i dati qui sotto.",
      home: "Home",
    },
    form: {
      title: "Ultimi dettagli",
      interventionType: "Tipo di intervento",
      types: { room: "Stanza", apartment: "Appartamento", building: "Edificio" },
      ceilingHeight: "Altezza soffitto (m)",
      openings: "Aperture esistenti",
      installations: "Impianti noti",
      notes: "Note libere",
      photos: "Foto della stanza (opzionale)",
      contact: "I tuoi contatti",
      name: "Nome",
      email: "Email",
      phone: "Telefono",
      send: "Invia progetto",
      success: "Progetto inviato! Ti risponderemo entro 2 giorni lavorativi.",
    },
  },
  staff: {
    login: "Accedi",
    email: "Email",
    password: "Password",
    logout: "Esci",
    dashboard: "Dashboard",
    tabs: { planimetries: "Planimetrie", bookings: "Prenotazioni", slots: "Slot calendario", portfolio: "Portfolio", services: "Servizi" },
    slots: { add: "Aggiungi slot", date: "Data", start: "Inizio", end: "Fine", delete: "Elimina" },
    bookings: { status: "Stato", pending: "In attesa", confirmed: "Confermata", completed: "Completata", cancelled: "Annullata" },
    portfolio: { add: "Nuovo progetto", edit: "Modifica", delete: "Elimina", save: "Salva", cancel: "Annulla" },
  },
  footer: { rights: "Tutti i diritti riservati.", made: "Progettato con cura." },
};

const en = {
  nav: { home: "Home", services: "Solutions", method: "Method", portfolio: "Portfolio", about: "About", contact: "Contact", teatro: "Dynamic Theatre", draw: "Draw", book: "Book a visit", staff: "Staff Area" },
  home: {
    eyebrow: "Architecture studio",
    heroTitle: "We design spaces that tell your story.",
    heroSub: "Innovative design with a unique showroom to visualise your projects at real scale.",
    ctaDraw: "Draw your room",
    ctaBook: "Book a visit",
    servicesTitle: "What we do",
    servicesSub: "Three ways to take care of your space.",
    methodTitle: "Our method",
    methodSub: "A simple, transparent, guided process.",
    portfolioTitle: "Latest projects",
    portfolioSub: "Recent studio projects.",
    seeAll: "See all projects",
  },
  services: {
    title: "Our Solutions",
    sub: "From design to execution, we offer complete solutions for every architectural and design need.",
    items: [
      { title: "Architectural Design", desc: "Tailored projects for residential and commercial buildings, with attention to detail and to the client's needs." },
      { title: "Dynamic Theater", desc: "One of a kind: a place where we reproduce your room at real scale with movable blocks to visualise furniture and dimensions." },
      { title: "Interior Design", desc: "Innovative solutions for interior spaces that combine functionality and aesthetics, creating unique and harmonious environments." },
      { title: "Consulting & Plans", desc: "In-depth analysis of the space and technical drawings with full support during execution." },
      { title: "Renovations", desc: "Refurbishment of existing buildings with modern solutions that respect the original structure and improve the spaces." },
      { title: "Site & Safety Management", desc: "End-to-end supervision of construction works to guarantee quality and respect timelines and budget." },
    ],
  },
  method: {
    title: "Our method",
    sub: "No jargon. Three clear steps to your project.",
    steps: [
      { n: "01", t: "Listening", d: "We understand together how you live and what you truly like." },
      { n: "02", t: "Guided drawing", d: "Use our tool to draw your idea, or send us a sketch. It takes a few minutes." },
      { n: "03", t: "Design & site", d: "We deliver the project and follow you, even on site, until the end." },
    ],
  },
  portfolio: { title: "Portfolio", sub: "Some of the projects we have built.", all: "All", year: "Year", categories: { residential: "Residential", commercial: "Commercial", interior: "Interior Design" } },
  contact: { title: "Let's talk", sub: "Write to us, we'll reply within 24 hours.", name: "Name", email: "Email", message: "Your message", send: "Send", sent: "Message sent. We'll be in touch soon!" },
  booking: {
    title: "Book a visit", sub: "Come see us at our showroom.",
    chooseSlot: "Pick a date and time", noSlots: "No available slots right now. Please try again later.",
    yourData: "Your details", name: "Full name", email: "Email", phone: "Phone", reason: "Reason for the visit (optional)",
    confirm: "Confirm booking", success: "Booking confirmed! Check your inbox.",
  },
  draw: {
    title: "Tell us about your space",
    sub: "<p>Already have an idea or want to reshape your room? <strong>Draw it in our tool</strong> in a simple way, then send us your sketch together with a few photos and your notes.</p><p><strong>You don't need to be a professional</strong>: your drawing helps us understand how you picture your space, what you want to change and what your needs are.</p><p>We gather all the information you provide and turn it into a <strong>clear and detailed technical drawing</strong>, which you can choose in a base or a detailed version.</p><ul><li><strong>Base technical drawing</strong>, to get a representation of your space.</li><li><strong>Detailed technical drawing</strong>, with furnishing advice and spatial layout, to help you develop your idea at its best.</li></ul><p><strong>You tell us how you picture your space. We turn your idea into a technical project.</strong></p>",
    modeSketch: "Free Drawing",
    modeSketchDesc: "Free drawing on a blank sheet.",
    modeGuided: "Grid Drawing",
    modeGuidedDesc: "Precise drawing on a grid with measurements in centimeters.",
    start: "Start", back: "Back",
    tools: { pencil: "Pencil", eraser: "Eraser", text: "Text", clear: "Clear", undo: "Undo" },
    guide1: "Start by drawing the perimeter of the room.",
    guide2: "Mark where doors and windows are.",
    guide3: "Write the measurements next to the walls (e.g. 3.5m).",
    guidedTools: { wall: "Wall", door: "Door", window: "Window", select: "Select", delete: "Delete" },
    guidedGuide1: "Click the first wall point, then type the length in cm and press Enter to draw it toward the cursor.",
    guidedGuide2: "Add doors and windows on top of the walls.",
    guidedGuide3: "When you're done, send the project: we'll generate the DXF file.",
    wizard: {
      stepOf: "Step {{n}}/4",
      backToDrawing: "Back",
      titles: {
        s1: "Project details",
        s2: "Your contacts",
        s3: "Choose your technical drawing",
        s4: "Payment method",
      },
      project: "Project",
      interventionType: "Type of intervention",
      interventions: {
        restructure: "Full room renovation",
        furniture: "Furniture replacement",
      },
      roomType: "Room type",
      roomOther: "Specify the room type",
      rooms: {
        living: "Living room", kitchen: "Kitchen", bedroom: "Bedroom",
        kids: "Kids room", bathroom: "Bathroom", office: "Study",
        entrance: "Entrance", dining: "Dining room", other: "Other",
      },
      notes: "Free notes",
      photos: "Room photos (optional)",
      photosSelected: "{{n}} photos selected",
      name: "Name", email: "Email", phone: "Phone",
      privacy: "I accept the ",
      privacyLink: "Privacy Policy",
      privacyRest: " and I consent to the processing of my data to manage the project and communicate with the studio.",
      pitch: "You tell us how you picture your space. We turn your idea into a technical project.",
      packages: {
        base: { name: "Base technical drawing", desc: "To get a technical representation of your space." },
        detail: { name: "Detailed technical drawing", desc: "With furnishing advice and spatial layout, to help you develop your idea at its best." },
      },
      perRoom: "per room",
      roomsCount: "Number of rooms",
      roomsHint: "The price is multiplied by each room",
      total: "Total",
      totalPreview: "Total",
      priceIncl: "VAT included",
      choosePay: "Choose how you want to pay.",
      pay: {
        stripe: { l: "Credit / debit card", d: "Secure Stripe checkout — Visa, Mastercard, Apple Pay, Google Pay" },
        bonifico: { l: "Bank transfer", d: "We'll show you IBAN and instructions after submitting — project starts when we receive it" },
        paypal: { l: "PayPal", d: "Secure redirect to PayPal — pay with your PayPal account or card" },
      },
      bonifico: {
        title: "Bank transfer details",
        holder: "Account holder",
        bank: "Bank",
        iban: "IBAN",
        causal: "Reference",
        amount: "Amount",
        holderVal: "Plan It Studio SRL STP",
        bankVal: "Intesa Sanpaolo — Spoleto branch, Piazza Garibaldi",
        note: "You'll receive a copy by email after submitting. The project will start when we receive the transfer.",
        successNote: "We've sent you a copy by email. The project will start when we receive the transfer.",
        yourName: "{name}",
      },
      next: "Next →",
      back: "← Back",
      submitPay: "Pay and send",
      submitSend: "Send project",
      sending: "…",
      successBonifico: "Project sent",
      successBonificoSub: "We have received your request. Complete the payment via bank transfer using the details below.",
      home: "Home",
    },
    form: {
      title: "Last details",
      interventionType: "Type of intervention",
      types: { room: "Room", apartment: "Apartment", building: "Building" },
      ceilingHeight: "Ceiling height (m)",
      openings: "Existing openings",
      installations: "Known systems",
      notes: "Free notes",
      photos: "Room photos (optional)",
      contact: "Your contacts", name: "Name", email: "Email", phone: "Phone",
      send: "Send project", success: "Project sent! We'll reply within 2 business days.",
    },
  },
  staff: {
    login: "Sign in", email: "Email", password: "Password", logout: "Sign out", dashboard: "Dashboard",
    tabs: { planimetries: "Plans", bookings: "Bookings", slots: "Calendar slots", portfolio: "Portfolio", services: "Services" },
    slots: { add: "Add slot", date: "Date", start: "Start", end: "End", delete: "Delete" },
    bookings: { status: "Status", pending: "Pending", confirmed: "Confirmed", completed: "Completed", cancelled: "Cancelled" },
    portfolio: { add: "New project", edit: "Edit", delete: "Delete", save: "Save", cancel: "Cancel" },
  },
  footer: { rights: "All rights reserved.", made: "Designed with care." },
};

i18n.use(initReactI18next).init({
  resources: { it: { translation: it }, en: { translation: en } },
  lng: localStorage.getItem("lang") || "it",
  fallbackLng: "it",
  interpolation: { escapeValue: false },
  returnObjects: true,
});

export default i18n;
